import {createSelector} from "@reduxjs/toolkit";
import {reviewCardSelector} from "../_selectors/reviewCard.selector";
import {formatInterval} from "../../utils/formatInterval";
import {reviewStoreSelector} from "../_selectors/reviewStore.selector";
import {reviewIntervals} from "../utils/reviewIntervals";

const MINUTES_PER_DAY = 24 * 60;

export const submitReviewButtonsSelector = createSelector(
    [
       reviewCardSelector,
       reviewStoreSelector
    ],
    (card, reviewStore) => {
        if (card === undefined)
            throw new Error('card cannot be undefined');

        const {again, hard, good, easy} = reviewIntervals(card);
        // Prefill for the Custom dialog: the card's current interval in whole days (min 1).
        const defaultCustomDays = Math.max(1, Math.round(card.interval / MINUTES_PER_DAY));
        return {
            again: again,
            hard,
            good,
            easy,
            formattedHard: formatInterval(hard),
            formattedGood: formatInterval(good),
            formattedAgain: formatInterval(again),
            formattedEasy: formatInterval(easy),
            defaultCustomDays,
            // Add multicard info
            isMultiCard: reviewStore.isMultiCard,
        }
    });
